import { Faculty } from './faculty.model';

export class Program {
  codigo: number;
  nombre: String;
  version: number;
  tipoProg: String;
  estado: String;
  semestreActual: String;
  facultad: Faculty;

}
